import { lazy } from 'react';

import { createSvgIcon } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { NavigationMenuCategory } from '~/src/app/components/Layout/components/NavigationMenu';

import Status from './pages/Status';

const Overview = lazy(() => import('./pages/Overview'));
const Labels = lazy(() => import('./pages/Transactions'));

export const ActivityRoutes = () => (
  <Routes>
    <Route element={<Overview />} path="overview" />
    <Route element={<Navigate to="overview" />} path="*" />
    <Route element={<Status />} path="status" />
    <Route element={<Labels />} path="labels" />
  </Routes>
);

const PackageIcon = createSvgIcon(
  <path
    fill="currentColor"
    d="M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z"
  />,
  'PackageIcon',
);

export const activityNavigationCategory: NavigationMenuCategory = {
  icon: <PackageIcon viewBox="0 -960 960 960" color="secondary" />,
  items: [
    {
      name: 'activity.items.overview',
      route: '/activity/overview',
    },
    {
      name: 'activity.items.labels',
      route: '/activity/labels',
    },
    {
      name: 'activity.items.status',
      route: '/activity/status',
    },
  ],
  name: 'activity.title',
};
